export default __webpack_public_path__ + "static/media/weekly_form_done.f6d873de.png";